import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { getAppConfigAction } from 'root-redux/actions/common'
import { TAppDispatch } from 'root-redux/store/store'

export const useInitAppConfig = (): void => {
  const dispatch: TAppDispatch = useDispatch()

  useEffect(() => {
    dispatch(getAppConfigAction())
  }, [dispatch])
}
